export const ROUTES = {
  CHECKOUT_CUSTOMER_INFORMATION: '/checkout/information',
  CHECKOUT_PAYMENT_INFORMATION: '/checkout/payment',
  CHECKOUT_THANK_YOU: '/checkout/thank-you',
  CHECKOUT_ORDER_STATUS: '/checkout/order-status',
};
